<template>
    <div class="error-page">
        <div class="au-card error-card">
            <div class="au-tile is-rose error-tile"><i class="bi bi-shield-lock"></i></div>
            <div class="error-code error-code-rose">403</div>
            <h1 class="error-title">{{ $t("errors.forbidden.title") }}</h1>
            <p class="error-text">{{ $t("errors.forbidden.text") }}</p>
            <router-link class="btn btn-primary" :to="{ name: 'Dashboard' }">
                <i class="bi bi-house-door"></i>{{ $t("errors.backToDashboard") }}
            </router-link>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "Forbidden",
});
</script>

<style scoped>
.error-page {
    min-height: 100vh;
    display: grid;
    place-items: center;
    padding: 24px 16px;
}

.error-card {
    width: 100%;
    max-width: 440px;
    padding: 40px 32px 36px;
    text-align: center;
}

.error-tile {
    width: 64px;
    height: 64px;
    border-radius: 20px;
    font-size: 30px;
    margin: 0 auto 18px;
}

.error-code {
    font-family: var(--au-font-head);
    font-size: 64px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -0.03em;
    color: var(--au-text);
}

.error-code-rose {
    background: var(--au-g-rose);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

.error-title {
    font-size: 22px;
    font-weight: 700;
    margin: 12px 0 6px;
}

.error-text {
    color: var(--au-muted);
    margin: 0 0 24px;
}
</style>
